import React from 'react';
import { Divider } from 'semantic-ui-react'

import ImprOS from '../../../components/funcionales/impros'

class VerOS1 extends React.Component {
  state={stImpr: false}

  handleClickImpr = () => {
    if(!this.props.permiteCancel&&!this.props.permiteClose&&!this.props.permiteDelete&&
      !this.props.permiteDir&&!this.props.permiteEqu&&!this.props.permiteOfer&&
      !this.props.permiteTar&&!this.props.permiteUpdate){
  
      this.setState({stImpr: true})
    }else{
      this.setState({stImpr: false})
    }
  }
  
  render(){
    const {stImpr} = this.state;

    let listOSCl = []
    listOSCl.push({listOS: this.props.idListaOS, cliente: this.props.cliente})

    const a01014505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014505" );
    const a01014510 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014510" );
    const a01014515 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014515" );
    const a01014520 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014520" );
    const a01014525 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014525" );
    const a01014530 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014530" );
    const a01014535 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014535" );
    const a01014540 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014540" );
// console.log(this.props.list)
    return (
    <div>
      <button className="ui right labeled icon button fluid" style={this.props.styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {((a01014505!==-1||a01014510!==-1||a01014515!==-1||a01014520!==-1||a01014525!==-1||a01014530!==-1||a01014535!==-1)&&this.props.estado==='ABIERTA') &&
        <div>
          {a01014505!==-1 &&
            <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickUpd}>
              <i className="large edit violet icon"></i>
              Modificar
            </button>
          }
          {a01014510!==-1 &&
          <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickCan}>
            <i className="large window close outline alternate violet icon"></i>
            Cancelar
          </button>
          }
          {a01014515!==-1 &&
          <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickClose}>
            <i className="large lock violet icon"></i>
            Cerrar
          </button>
          }

      {((a01014520!==-1||a01014525!==-1||a01014530!==-1||a01014535!==-1)&&(this.props.list[0].permDireccion!=='DEJAR IGUAL'||
        (this.props.list[0].permTarServ!=='DEJAR IGUAL'&&this.props.list[0].permTarServ!=='IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS')||
        this.props.list[0].permOfertas!=='NO'||this.props.list[0].permEquipos==='AGREGAR - RETIRAR')) &&
        <div>
          <Divider inverted />

          <button className="ui right labeled icon button fluid" style={this.props.styles.titBuscar}>
            <i className="large edit yellow icon"></i>
            Actualizar
          </button>
        </div>
      }

      {(a01014520!==-1&&this.props.list[0].permDireccion!=='DEJAR IGUAL') &&
        <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickDir}>
          <i className="large map marker alternate violet icon"></i>
          Dirección
        </button>
      }

      {(a01014525!==-1&&(this.props.list[0].permTarServ!=='DEJAR IGUAL'&&this.props.list[0].permTarServ!=='IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS')) &&
        <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickTar}>
          <i className="large newspaper outline violet icon"></i>
          Tarifa / Servicios
        </button>
      }

      {/* {(a01014530!==-1&&this.props.list[0].permOfertas!=='NO') &&
        <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickOfer}>
          <i className="large magic violet icon"></i>
          Oferta
        </button>
      } */}

      {(a01014535!==-1&&this.props.list[0].permEquipos==='AGREGAR - RETIRAR') &&
        <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickEqu}>
          <i className="large hdd outline violet icon"></i>
          Equipos
        </button>
      }
          <Divider inverted />
      </div>
      }
      {(a01014540!==-1&&this.props.estado!=='CANCELADA'&&this.props.list[0].permImprimir==="SI") &&
        <div>
          <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.handleClickImpr}>
            <i className="large print violet icon"></i>
            Imprimir
          </button>
          {/* {(stImpr&&!this.props.permiteCancel&&!this.props.permiteClose&&!this.props.permiteDelete&&
            !this.props.permiteDir&&!this.props.permiteEqu&&!this.props.permiteOfer&&
            !this.props.permiteTar&&!this.props.permiteUpdate) && */}
          {(!this.props.permiteCancel&&!this.props.permiteClose&&!this.props.permiteDelete&&
            !this.props.permiteDir&&!this.props.permiteEqu&&!this.props.permiteOfer&&
            !this.props.permiteTar&&!this.props.permiteUpdate) &&
              <ImprOS listOSCl={listOSCl} empresa={this.props.empresa} stImpr={stImpr} hoy={this.props.hoy}/>
          }

          <Divider inverted />

        </div>
      }
      <button className="ui labeled icon button fluid" style={this.props.styles.dropdown} onClick={this.props.handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
    }
};

export default VerOS1
